import { createFileRoute, redirect } from "@tanstack/react-router";
import { Role } from "@/core/components/auth/auth.types";

// Editor can list agents but not create them.
const CREATE_ROLES = [
	Role.Internal,
	Role.Reseller,
	Role.Organizator,
	Role.PropertyManager,
];

export const Route = createFileRoute("/_layout/dashboard/sales-agents/create/")(
	{
		beforeLoad: ({ context: { auth } }) => {
			if (auth.isExpired()) {
				return;
			}
			if (!auth.isAuthenticated) {
				throw redirect({
					to: "/",
				});
			}
			if (!auth.user?.role || !CREATE_ROLES.includes(auth.user.role)) {
				throw redirect({
					to: "/dashboard",
				});
			}
		},
	},
);
